<template>
  <div>
    <lcontainer
      v-if="tenant.tenant_profile && tenant.tenant_profile.company_name"
      class="mb-4"
    >
      <div class="heading  py-4 px-8">
        <div class="page text-white">
          {{ tenant.tenant_profile.company_name }}
        </div>
        <span class="text-white">{{ tenant.role }}</span>
      </div>
    </lcontainer>

    <lcontainer>
      <div class="py-4 px-8">
        <div class="flex justify-between">
          <page-header class="py-2">User Information</page-header>
        </div>
        <div class="w-full md:w-1/2 items-center form-row m-4 px-4">
          <div class="flex flex-row justify-between my-4">
            <div class=" font-semibold">First Name:</div>
            <div>
              <p>{{ tenant.first_name }}</p>
            </div>
          </div>
          <div class="flex flex-row justify-between my-4">
            <div class=" font-semibold">Last Name:</div>
            <div>
              <p>{{ tenant.last_name }}</p>
            </div>
          </div>
          <div class="flex flex-row justify-between my-4">
            <div class=" font-semibold">Email:</div>
            <div>
              <p>{{ tenant.email }}</p>
            </div>
          </div>
          <div class="flex flex-row justify-between my-4">
            <div class=" font-semibold">Phone Number:</div>
            <div>
              <p>{{ tenant.phone_number }}</p>
            </div>
          </div>
          <div class="flex flex-row justify-between my-4">
            <div class=" font-semibold">Country:</div>
            <div>
              <p>{{ tenant.country }}</p>
            </div>
          </div>
          <div class="flex flex-row justify-between my-4">
            <div class=" font-semibold">State:</div>
            <div>
              <p>{{ tenant.state }}</p>
            </div>
          </div>
          <div class="flex flex-row justify-between my-4">
            <div class=" font-semibold">Gender:</div>
            <div>
              <p>{{ tenant.gender }}</p>
            </div>
          </div>
          <div class="flex flex-row justify-between my-4">
            <div class=" font-semibold">User Type:</div>
            <div>
              <p>Tenant</p>
            </div>
          </div>
          <div class="flex flex-row justify-between my-4">
            <div class=" font-semibold">Role:</div>
            <div>
              <p>{{ tenant.role }}</p>
            </div>
          </div>
        </div>
        <div />
      </div>
      <div class="py-4 px-8">
        <lms-blue-button @click="navigate(tenant.id)"
          >Edit Permissions</lms-blue-button
        >
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    LmsBlueButton: () => import("@/components/general/button"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
  },
  data() {
    return {
      tenant: {},
      form: {},
      search: "",
    };
  },
  async created() {
    this.tenant = await this.fetchSingleTenant({
      id: this.$route.params.id,
    });
  },
  methods: {
    ...mapActions(["fetchSingleTenant"]),
    navigate(id) {
      this.$router.push({
        name: "admin-tenant-permission",
        params: { id: id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.program-main {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
}

.program-content {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
}

.form-row {
  .modal-title {
    font-size: 24px;
    color: color(lms-admin);
  }

  .modal-field {
    color: color(lms-admin);
    margin-right: 4rem;
  }
  .close {
    background-color: #c2454b;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    font-size: 12px;
    top: -17px;
    z-index: 2;
    right: 11px;
  }
  z-index: 1;
  // max-width: 500px;
}
</style>
